import React, { FC } from 'react';
import { useTranslations, TranslationKey } from '@lang';
import { TextWithIconWrapper } from './TextWithIcon.styles';

export type TextWithIconProps = {
  textId: TranslationKey;
  icon: JSX.Element;
};

export const TextWithIcon: FC<TextWithIconProps> = ({ icon, textId }) => {
  const { t } = useTranslations();
  return (
    <TextWithIconWrapper>
      {icon}
      {t(textId)}
    </TextWithIconWrapper>
  );
};
